import { DateObject } from "react-multi-date-picker";
import axios from "../httpHandler";

export const getProducts = async (filters) => {
  try {
    const result = await axios.get(`concentrate${filters}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getAllProducts = async () => {
	try {
	  const inputsCall = await axios.get(`input`);
	  const ingredientsCall = await axios.get(`ingredient`);

	  return [...inputsCall?.data?.data ?? [], ...ingredientsCall?.data?.data ?? []];
	} catch (error) {
	  console.log(error);
	  throw error;
	}
  };

export const getProductStatistics = async (filters) => {
  try {
    const result = await axios.get(`concentrate/statistics${filters}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const createProduct = async ({ productsList, description }) => {
  const items = productsList.map((product) => ({
    "amount": parseFloat(`${product?.amount ?? '0'}`.replaceAll(',', '')),
    "unit_id": product.unit.value,
    "food_item_id": product.input.value
  }));

  const date = new DateObject();
  return axios.post(`concentrate`, {
    date: date.format("YYYY-MM-DD"),
    description,
    items,
  });
};

export const deleteProductItem = async ({ id, warehouseSelected }) => {
  const queryParams = warehouseSelected ? '?update_warehouse' : '';
  return axios.delete(`concentrate/item/${id}${queryParams}`);
};

export const updateProduct = ({ id, removedItems, addedItems, description }) => {
  const removed_items = removedItems.map((product) => product.item_id);

  const added_items = addedItems.map((product) => ({
    "amount": parseFloat(`${product?.amount ?? '0'}`.replaceAll(',', '')),
    "unit_id": product.unit.value,
    "food_item_id": product.input.value
  }));

  const date = new DateObject();
  const sample = {
    date: date.format("YYYY-MM-DD"),
    description,
    removed_items,
    added_items,
  };

  return axios.put(`concentrate/${id}`, sample);
};
